import './MonitorCapability.css';

export default function MonitorCapability() {
  return (
    <div id='monitor-capability' className='outsourcemainclass'>
         <div className="overlaynew"></div>
<div className="left">
     <div className="overlay"></div>
<div className="content">
    <h2>Why Choose BastionEx for Configuration Management?</h2>
<p>A structured and reliable approach to managing infrastructure efficiently, ensuring consistency, stability, and long-term operational success.</p>
</div>
</div>
<div className="right">
    <div className="overlay"></div>
<div className="content">
    <div className="item">
        <h3>Proven DevOps and Cloud Expertise</h3>
        <span>BastionEx brings deep expertise in DevOps practices and cloud technologies, delivering reliable configuration management solutions across complex infrastructures.</span>
    </div>
    <div className="item">
        <h3>Secure, Compliant Solutions for Enterprise and Healthcare Environments</h3>
        <span>We embed security controls and compliance standards into configurations, ensuring alignment with enterprise policies and healthcare regulatory requirements.</span>
    </div>
    <div className="item">
        <h3>Customized Configuration Strategies Aligned with Business Goals</h3>
        <span>Our configuration management strategies are tailored to your infrastructure, workflows, and business objectives to deliver measurable and sustainable outcomes.</span>
    </div>
    <div className="item">
        <h3>Proven DevOps and Cloud Expertise</h3>
        <span>BastionEx brings deep expertise in DevOps practices and cloud technologies, delivering reliable configuration management solutions across complex infrastructures.</span>
    </div>
</div>
</div>
    </div>
  )
}
